import "@babel/polyfill";
import es6Promise from "es6-promise";
es6Promise.polyfill();

import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import Adal from "vue-adal";
import App from "./App.vue";
import moment from "moment-timezone";
import VueSignaturePad from "vue-signature-pad";

import JsonExcel from "vue-json-excel";

import vuetify from "./plugins/vuetify";

Vue.prototype.moment = moment;

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueSignaturePad);

Vue.component("downloadExcel", JsonExcel);

const routes = [
  {
    path: "/",
    component: () => import("./components/Login.vue"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/upload",
    component: () => import("./components/UploadPhoto.vue"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/photos/:id",
    component: () => import("./components/ViewPhotos.vue"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/login",
    component: () => import("./components/Login.vue"),
    alias: "/",
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/admin",
    component: () => import("./components/Admin.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/admin/loginStats",
    component: () => import("./components/AdminLoginStats.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/admin/viewStats/:id/:backId",
    component: () => import("./components/AdminPhotoStats.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/admin/:id",
    component: () => import("./components/AdminEvent.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/map",
    component: () => import("./components/Map.vue"),
    props: route => ({
      lat: route.query.lat,
      long: route.query.lat,
      name: route.query.name,
      address: route.query.address
    }),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/sign/:id",
    component: () => import("./components/Signature.vue"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/api",
    meta: {
      requireAuth: false
    }
  },
  {
    path: "*",
    component: () => import("./components/Redirect.vue"),
    meta: {
      requireAuth: false
    }
  }
];

const store = new Vuex.Store({
  state: {
    baseURL: process.env.VUE_APP_API_BASE_URL,
    auditEvent: null,
    auditorID: null
  },
  getters: {
    getBaseUrl: state => {
      return state.baseURL;
    },
    getAuditEvent: state => {
      return state.auditEvent;
    },
    getAuditorID: state => {
      return state.auditorID;
    }
  },
  mutations: {
    setAuditEvent(state, auditEvent) {
      state.auditEvent = auditEvent;
    },
    setAuditorID(state, auditorID) {
      state.auditorID = auditorID;
    }
  },
  actions: {
    setAuditEvent(context, auditEvent) {
      context.commit("setAuditEvent", auditEvent);
    },
    setAuditorID(context, auditorID) {
      context.commit("setAuditorID", auditorID);
    }
  }
});

const router = new VueRouter({
  mode: "history",
  routes: routes
});

Vue.use(Adal, {
  // This config gets passed along to Adal, so all settings available to adal can be used here.
  config: {
    // 'common' (multi-tenant gateway) or Azure AD Tenant ID
    // Directory ID in AAD Properties
    tenant: process.env.VUE_APP_TENANT,

    // Application ID
    clientId: process.env.VUE_APP_CLIENT_ID,

    // Host URI
    redirectUri: process.env.VUE_APP_REDIRECT_URI,

    cacheLocation: "localStorage"
  },

  // Set this to true for authentication on startup
  requireAuthOnInitialize: false,

  // Pass a vue-router object in to add route hooks with authentication and role checking
  router: router
});

Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount("#app");
